"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useBoolean_1 = __importDefault(require("./useBoolean"));
var useDebounce = function (value, delay) {
    if (delay === void 0) { delay = 800; }
    var _a = react_1.useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    var isDebouncing = useBoolean_1.default(false);
    react_1.useEffect(function () {
        isDebouncing.setTrue();
        var handler = setTimeout(function () {
            setDebouncedValue(value);
            isDebouncing.setFalse();
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [value]);
    return { isDebouncing: isDebouncing.value, debouncedValue: debouncedValue };
};
exports.default = useDebounce;
